import { render, staticRenderFns } from "./RequestRegular.view.vue?vue&type=template&id=5fe2f8aa&"
import script from "./RequestRegular.view.vue?vue&type=script&lang=js&"
export * from "./RequestRegular.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports